import { Injectable } from "@angular/core";
import { Endpoint, IApiResponse, IHttpLogin } from "src/app/models";
import { HttpService } from "../http.service";
import { HTTP_METHOD } from ".";
import { firstValueFrom } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LoginApiService {
  #login = "Login" as Endpoint;

  constructor(private http: HttpService) {}

  /**
   * "Login" occurs after Firebase auth to retrieve user details from cloud DB
   * @returns {Promise<IApiResponse<IHttpLogin>>} User data
   */
  async userLogin(): Promise<IApiResponse<IHttpLogin>> {
    return firstValueFrom(
      this.http.request$<IHttpLogin>(HTTP_METHOD.POST, this.#login, {
        skipCheck: true,
      })
    );
  }
}
